<template>
  <v-card color="white">
      <v-container>
        <v-row>
          <v-col cols="12" lg="6">
            <b class="help-step" style="cursor:help;" @click="show_help($t('teamMembers.text'), $t('Step5.search'))">
              {{$t('teamMembers.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span v-html="$t('Step5.search')"></span>
              </v-tooltip>
            </b>

            <v-row class="mt-3" v-for="(item, i) in all_teams" v-if="item.is_active == true" :key="i">
              <v-col style="margin: auto;" class="pa-0  d-flex flex-nowrap ">
                <p class="ml-8 mb-0" style="font-size: 14px">
                  {{item.team_profile.individual.last_name}} {{item.team_profile.individual.first_name}} {{item.team_profile.individual.middle_name}}
                </p>
                <v-tooltip right v-if="(item.creator == GETTERS_CURRENT_USER.id)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      color="red lighten-1"
                      @click="delete_from_team(item)"
                      style="margin-left: 8px !important;">
                      mdi-delete
                      </v-icon>
                  </template>
                <span>удалить</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="pl-8 pr-3 mb-6">
              <div class="input-container">
                <user-search
                  :attached_list="all_teams"
                  :full_view="false"
                  @addUser="add_user_to_team($event)"
                />
              </div>
            </v-row>

            <b class="help-step" style="cursor:help;" @click="show_help($t('localContactLabel.text'), $t('localContactLabel.help'))">
              {{$t('localContactLabel.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span v-html="$t('localContactLabel.help')"></span>
              </v-tooltip>
            </b>
            <v-text-field
              v-model="localContact"
              outlined
              type="text"
              counter="200"
              maxLength="200"
            ></v-text-field>

          </v-col>
          <v-col cols="12" lg="6">
            <b class="help-step" style="cursor:help;" @click="show_help($t('teamWorkAbilityAtNight.text'), $t('teamWorkAbilityAtNight.help'))">
              {{$t('teamWorkAbilityAtNight.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span v-html="$t('teamWorkAbilityAtNight.help')"></span>
              </v-tooltip>
            </b>
            <v-switch
              :color="$mainColor"
              v-model="workNight"
            ></v-switch>
            
            <b class="help-step" style="cursor:help;" @click="show_help($t('dateRangeLabel.text'), $t('dateRangeLabel.help'))">
              {{$t('dateRangeLabel.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span v-html="$t('dateRangeLabel.help')"></span>
              </v-tooltip>
            </b>
            <div class="input-container input-container-date">
              <v-chip 
                v-if="errorDateRange"
                color="red"
                x-small
                style="width:40px">
              </v-chip>
              <v-date-picker
                :flat='true'
                :elevations='0'
                style='box-shadow:none'
                v-model="dateRange"
                :color="$mainColor"
                width="800"
                class='mt-5 mb-5'
                locale='ru'
                full-width
                range
                first-day-of-week="1"
              ></v-date-picker>
            </div>
          </v-col>
        </v-row>
      </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import userSearch from '../Common/user-search/userSearch.vue'

export default {
  props: [
    'can_work_at_night',
    'teams',
    'experiment_calendar',
    'local_contacts'
  ],

  name: 'SelectionDate',

  components: {
    userSearch,
  },

  data() {
    return {
      errorLocalContact: false,
      errorDateRange: false,
      dateRange: this.experiment_calendar,
      localContact: this.local_contacts,
      lastName: [],
      workNight: this.can_work_at_night,
      menu2: false,
      menu: false,
      date: new Date().toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      comment: '',
      errorComment: false,
      errorDateFrom: false,
      errorDateTo: false,
      all_teams: this.teams,
      resultSearch: [],
      rules: {
        required: (value) => (value === null || value.length === 0) ? this.$t('required') : true,
      },
    };
  },

  watch: {
    async workNight(val) {
      this.UPDATE_QUIZE({can_work_at_night: val});
    },

    async localContact(val) {
      this.UPDATE_QUIZE({local_contacts: val});
    },

    async dateRange(val) {
      var dates = null
      if(val[0] !== undefined){
        if(val[1] == undefined)
          dates = `${val[0]}:${val[0]}`
        else{
          if(val[0] > val[1]){
            dates = `${val[1]}:${val[0]}`
          }
          else{
            dates = `${val[0]}:${val[1]}`
          }
        }
      }
      this.UPDATE_QUIZE({experiment_calendar: dates});
    },

  },

  computed: {
    ...mapGetters([
      'GETTERS_CURRENT_USER',
    ]),
    teamMembers(){
      return this.$t('teamMembers')
    },
    teamWorkAbilityAtNight(){
      return this.$t('teamWorkAbilityAtNight')
    },
    dateRangeLabel(){
      return this.$t('dateRangeLabel')
    },
  },

  methods: {
    ...mapActions([
      'PROPOSAL_CHANGE_TEAM',
    ]),

    ...mapMutations([
      'UPDATE_QUIZE',
      'UPDATE_HELPER_DIALOG',
      'UPDATE_OVERLAY',
    ]),
    
    show_help(header = '', text = ''){
      this.UPDATE_HELPER_DIALOG({
        'show' : true,
        'helper_data': {
          'header': header,
          'text': text,
        }
      })
    },

    add_user_to_team(profile_id){
      this.UPDATE_OVERLAY(true)
      this.PROPOSAL_CHANGE_TEAM({
        'type': 'add',
        'proposal_id': this.$route.params.id,
        'profile_id': profile_id,
      })
      .then((data) => {
        this.UPDATE_OVERLAY(false)
        if(data.error){
          this.$messageHelper(data.error, 'error', 3000);
        }
        else{
          this.all_teams = data.all_teams
        }
      })
    },

    delete_from_team(item){
      this.UPDATE_OVERLAY(true)
      this.PROPOSAL_CHANGE_TEAM({
        'type': 'delete',
        'proposal_id': this.$route.params.id,
        'users': {proposal_team_id: item.id},
      })
      .then((data) => {
        this.UPDATE_OVERLAY(false)
        if(data.error){
          this.$messageHelper(data.error, 'error', 3000);
        }
        else{
          this.all_teams = data.all_teams
        }
      })
    },
  },
};
</script>

<style scoped>
  .input-container-date {
    max-width: 400px;
  }
  .input-container {
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100%;
  }

  .input-container__search-user,
  .input-container__search-result {
      max-width: auto;
      width: 100%;
  }
  .input-container__search-user {
    min-width: 300px;
  }
  .input-container__search-result {
    margin-left: 15px;
    height: 130px;
    overflow-y: auto;
    max-width: 180px;
    min-width: 180px;
  }
  .input-container__search-result .v-card__title {
    font-size: 16px;
  }
</style>

<style>
  .input-container-date .v-picker__title {
    display: none !important;
  }
</style>
